import {
  RERIEVE_CART,
  ADD_TO_CART,
  REMOVE_FROM_CART,
} from "./cart-actionTypes";
import { Cart } from "./cart-types";

export function retrieve_cart_action(payload: Cart) {
  return {
    type: RERIEVE_CART,
    payload,
  };
}

export function add_to_cart_action() {
  return {
    type: ADD_TO_CART,
  };
}

export function remove_from_cart_action() {
  return {
    type: REMOVE_FROM_CART,
  };
}
